import { PublicClient } from "viem";
import { GetSessionKeyResponse } from "../types/session-key-types";
import { getSessionKey } from "./get-session-key";
import { isSessionKeyLiveOnChain } from "./erc20-sessionkey-onchain";

export const isAValidSessionKey = async(
  publicClient: PublicClient, 
  sesssionKeyValidatorAddress: string,
  etherspotWalletAddress: string, 
  chainId: number, 
  apiKey: string, 
  sessionKey: string): Promise<boolean> => {

    // get sessionKey from apiKey and account (from remote secure storage)
    const sessionKeyResponse: GetSessionKeyResponse = await getSessionKey(etherspotWalletAddress, chainId, apiKey, sessionKey);

    if (!sessionKeyResponse || !sessionKeyResponse.sessionKey || sessionKeyResponse.sessionKey == '') {
      console.log(`Sessionkey: ${sessionKey} not found for etherspotWalletAddress: ${etherspotWalletAddress} and apiKey: ${apiKey} on chainId: ${chainId}`);
      return false;
    }

    // check if sessionKey is live onchain (sessionKeyValidator contract)
    const isLiveOnChain = await isSessionKeyLiveOnChain(
      etherspotWalletAddress,
      publicClient,
      sesssionKeyValidatorAddress,
      sessionKeyResponse.sessionKey); 

    if(!isLiveOnChain) {
      console.warn(`Sessionkey: ${sessionKey} is not live for etherspotWalletAddress: ${etherspotWalletAddress} and apiKey: ${apiKey
      } on chainId: ${chainId}`);
      return false;
    }

    return true;
  }
